export default {
    "name": "SearchAddress",
    "kind": "HoudiniQuery",
    "hash": "f2ae1e1e97a6e8908dc4218c7df08e9bcf138d7b6e4ffdc1e832bb5e8021234c",

    "raw": `query SearchAddress($query: String!, $proximity: CoordinatesInput!) {
  searchAddress(input: {query: $query, proximity: $proximity}) {
    score
    formattedName
    contextualizedName
    address {
      city
      department
      region
      country {
        code
      }
      zipCode
    }
    mapLocation {
      location {
        lng
        lat
      }
      viewPort {
        northeast {
          lat
          lng
        }
        southwest {
          lat
          lng
        }
      }
    }
    entityType
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "searchAddress": {
                "type": "SearchAddressResult",
                "keyRaw": "searchAddress(input: {query: $query, proximity: $proximity})",

                "selection": {
                    "fields": {
                        "score": {
                            "type": "Float",
                            "keyRaw": "score",
                            "visible": true
                        },

                        "formattedName": {
                            "type": "String",
                            "keyRaw": "formattedName",
                            "visible": true
                        },

                        "contextualizedName": {
                            "type": "String",
                            "keyRaw": "contextualizedName",
                            "nullable": true,
                            "visible": true
                        },

                        "address": {
                            "type": "Address",
                            "keyRaw": "address",

                            "selection": {
                                "fields": {
                                    "city": {
                                        "type": "String",
                                        "keyRaw": "city",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "department": {
                                        "type": "String",
                                        "keyRaw": "department",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "region": {
                                        "type": "String",
                                        "keyRaw": "region",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "country": {
                                        "type": "Country",
                                        "keyRaw": "country",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "zipCode": {
                                        "type": "String",
                                        "keyRaw": "zipCode",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "mapLocation": {
                            "type": "MapLocation",
                            "keyRaw": "mapLocation",

                            "selection": {
                                "fields": {
                                    "location": {
                                        "type": "Coordinates",
                                        "keyRaw": "location",

                                        "selection": {
                                            "fields": {
                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                },

                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "viewPort": {
                                        "type": "CoordinateBounds",
                                        "keyRaw": "viewPort",

                                        "selection": {
                                            "fields": {
                                                "northeast": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "northeast",

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "southwest": {
                                                    "type": "Coordinates",
                                                    "keyRaw": "southwest",

                                                    "selection": {
                                                        "fields": {
                                                            "lat": {
                                                                "type": "Float",
                                                                "keyRaw": "lat",
                                                                "visible": true
                                                            },

                                                            "lng": {
                                                                "type": "Float",
                                                                "keyRaw": "lng",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "entityType": {
                            "type": "SearchAddressEntityType",
                            "keyRaw": "entityType",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "query": "String",
            "proximity": "CoordinatesInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=240239eeac7fe7b878d6825068b4e42da38ebf597ba4cecd8e47c53a3a31681b";